import React, { memo } from "react";
import classNames from "classnames";

import "./IndeterminateCheckbox.scss";

import CheckedIcon from "static/icons/checked.svg";
import IndeterminateIcon from "static/icons/indeterminate.svg";

export const indeterminateCheckboxTypes = Object.freeze({
  checked: "checked",
  unchecked: "unchecked",
  indeterminate: "indeterminate"
})

const IndeterminateCheckbox = ({ label, status, onChange }) => {

  const handleClick = () => {

    const isChecked = status === indeterminateCheckboxTypes.checked ? true : false;

    onChange(isChecked);
  };

  return (
    <div
      className="universal-checkbox"
      onClick={handleClick}
    >
      <div
        className={classNames({
          "universal-checkbox__indicator": true,
          "universal-checkbox__indicator--checked": status === indeterminateCheckboxTypes.checked,
          "universal-checkbox__indicator--indeterminate": status === indeterminateCheckboxTypes.indeterminate,
        })}
      >
        {
          status === indeterminateCheckboxTypes.checked ? <img src={CheckedIcon} /> :
          status === indeterminateCheckboxTypes.indeterminate ? <img src={IndeterminateIcon} /> : null
        }
      </div>
      {label}
    </div>
  );
};

export default memo(IndeterminateCheckbox);